export default "assets/images/icons/shop-61a70e29.svg";